module.exports = __webpack_public_path__ + "static/media/zera_putting_rectangle.25db0289.gif";